import { render, staticRenderFns } from "./operation-board-order.vue?vue&type=template&id=b07fe620&scoped=true&"
import script from "./operation-board-order.vue?vue&type=script&lang=js&"
export * from "./operation-board-order.vue?vue&type=script&lang=js&"
import style0 from "./operation-board-order.vue?vue&type=style&index=0&id=b07fe620&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b07fe620",
  null
  
)

export default component.exports